query GetAccountUsageHistory($accountId: ID!) {
  history: StreamToolsGetAccountUsageHistory(accountId: $accountId) {
    month
    estimatedCents
    counters {
      votesIngested
      uploads
      uploadBytes
      republishes
      overlayTokenMints
      ticketExchanges
      ytUnits
      ytSessionsStarted
      ytSessionSeconds
      eventsCreated
      chatOverlaysCreated
      emoteWallsCreated
      merchOverlaysCreated
      pollsCreated
      tugsCreated
      boardsCreated
    }
  }
}
